import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter, withInMemoryScrolling } from "@angular/router";
import { Amplify } from "aws-amplify";
import { routes } from "./app.routes";
import { provideHttpClient } from "@angular/common/http";
import { environment } from "../environments/environment";
import { AuthService } from "./core/services/auth.service";
import { provideNativeDateAdapter } from "@angular/material/core";
import { AppInitializerService } from "./core/services/app-initializer.service";
import { WafCaptchaService } from './core/services/waf-captcha.service';

export function appInitializerFactory(initService: AppInitializerService) {
  return () => initService.initializeUserData();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
    ),
    provideHttpClient(),
    provideNativeDateAdapter(),
    {
      provide: "awsConfig",
      useValue: environment.awsConfig,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (waf: WafCaptchaService) => () => waf.init(),
      deps: [WafCaptchaService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [AppInitializerService],
      multi: true,
    },
    AuthService,
  ],
};

Amplify.configure(environment.awsConfig);
